import session from "./session";

export default {
  loadSMSTemplates(kind, sub_kind) {
    return session.get(`/sms/templates/?kind=${kind}&sub_kind=${sub_kind}`);
  },

  previewSMSTemplate(template_id, kind, instance_id) {
    return session.post(`/${kind}s/${instance_id}/actions/preview-sms/`, {template_id});
  },

  sendSMS(template_id, kind, instance_id) {
    return session.post(`/${kind}s/${instance_id}/actions/send-sms/`, {template_id});
  },
};
